import React, { Component } from 'react'
import { render } from 'react-dom'

import { 
  LineChart,
  Line,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts'

import '../../App.css'

import { InlineMath, BlockMath } from 'react-katex';

import {
  Container,
  Header,
} from 'semantic-ui-react'

import 'katex/dist/katex.min.css';

import * as ss from 'simple-statistics'

import Graph from './graph'

const gamma = require('gamma')

const norm_mu_init = 0
const norm_sigma_init = 1

const max_plot = 30


var get_norm_arg_list = function(mu,sigma) {

  var mu = Number(mu)
  var sigma = Number(sigma)
  
  var sigma_m5 = mu - 5 * sigma
  var sigma_p5 = mu + 5 * sigma

  // var sigma_m5 = mu - 5 * mu
  // var sigma_p5 = mu + 5 * mu

  var arg_list = []
  for(var i = 0; i <= max_plot; i++ ) {
    arg_list.push(sigma_m5 + i * (sigma_p5 - sigma_m5) / max_plot)
  }
  return arg_list
}

var get_norm_list = function(mu,sigma) {

  var mu = Number(mu)
  var sigma = Number(sigma)

  var array = []
  for(var arg of get_norm_arg_list(mu, sigma)){
    var value = (1 / 2 / Math.PI / sigma**2)**(0.5) * Math.E ** (-1 * ((arg - mu) / Math.sqrt(2) / sigma) ** 2 )
    array.push(value)
  }
  return array
}


class Norm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      mu: norm_mu_init,
      sigma: norm_sigma_init,
      aNorm: get_norm_arg_list(norm_mu_init,norm_sigma_init).map((a) => Number(a.toFixed(3))),
      vNorm: get_norm_list(norm_mu_init,norm_sigma_init).map((a) => Number(a.toFixed(3))),
    };

  }

  onNormMuChangeHandler = (event) => {
    if (event.target.value != "") {
      this.setState({ 
        mu: event.target.value,
        sigma: this.state.sigma,
        aNorm: get_norm_arg_list(event.target.value,this.state.sigma).map((a) => Number(a.toFixed(3))),
        vNorm: get_norm_list(event.target.value,this.state.sigma).map((a) => Number(a.toFixed(3))),
      });
    } else {
      this.setState({ 
        mu: norm_mu_init,
        sigma: this.state.sigma,
        aNorm: get_norm_arg_list(norm_mu_init,this.state.sigma).map((a) => Number(a.toFixed(3))),
        vNorm: get_norm_list(norm_mu_init,this.state.sigma).map((a) => Number(a.toFixed(3))),
      });
    }
  }

  onNormSigmaChangeHandler = (event) => {
    if (event.target.value != "") {
      this.setState({ 
        mu: this.state.mu,
        sigma: event.target.value,
        aNorm: get_norm_arg_list(this.state.mu,event.target.value).map((a) => Number(a.toFixed(3))),
        vNorm: get_norm_list(this.state.mu,event.target.value).map((a) => Number(a.toFixed(3))),
      });
    } else {
      this.setState({ 
        mu: this.state.mu,
        sigma: norm_sigma_init,
        aNorm: get_norm_arg_list(this.state.mu,norm_sigma_init).map((a) => Number(a.toFixed(3))),
        vNorm: get_norm_list(this.state.mu,norm_sigma_init).map((a) => Number(a.toFixed(3))),
      });
    }
  }


  render() {

    var list = []
    if(this.state.mu !== "" && this.state.sigma !== "") {
      if(this.state.vNorm.length != 0) {
        for(var i = 0; i < this.state.vNorm.length; i++){
          list.push(<tr><td className="td_01">{this.state.aNorm[i]}</td><td className="td_01">{this.state.mu}</td><td className="td_01">{this.state.sigma}</td><td className="td_01">{(100 * this.state.vNorm[i]).toFixed(2)} % </td></tr>)
        }
      }
    }

    var norm_data = [];
    if(this.state.mu !== "" && this.state.sigma !== "") {
      if(this.state.vNorm.length !== 0) {
        for(var i = 0; i < this.state.vNorm.length; i++){
          // norm_data.push({name: this.state.aNorm[i], pdf: this.state.vNorm[i], cdf: this.state.vNorm.slice(0, i + 1).reduce((total, data) => {return (10 * this.state.sigma * Number((total + data).toFixed(3)) / max_plot) < 1 ? 10 * this.state.sigma * Number((total + data).toFixed(3)) / max_plot : 1})})
          
          norm_data.push({name: this.state.aNorm[i], pdf: this.state.vNorm[i], cdf: 10 * this.state.sigma * this.state.vNorm.slice(0, i + 1).reduce((a, b) => ( a + b ) ) / max_plot})
        }
      }
    }

    return (
      <div className="base">

        <Header as='h1'>
        正規分布 
        </Header>
      
        <BlockMath>{`

        P\\left(X | \\mu, \\sigma \\right) = \\frac{1}{\\sqrt{2 \\pi \\sigma^2}}\\exp\\left({-\\frac{\\left(x - \\mu\\right)^2}{2\\sigma^2}}\\right)

       `}</BlockMath>

        <div style={{ textAlign: 'center' }}>
          <div>
            <Header as='h1'>
            input : <InlineMath>{`\\displaystyle \\mu `}</InlineMath>
            <input onChange={this.onNormMuChangeHandler} style={{"margin-left":"20px"}}/>
            </Header>
            <Header as='h1'>
            input : <InlineMath>{`\\displaystyle \\sigma `}</InlineMath>
            <input onChange={this.onNormSigmaChangeHandler} style={{"margin-left":"20px"}}/>
            </Header>
          </div>
        </div>

        <Graph data={norm_data}/>
        
        <table border="1" className="table_base">
            <tr>
              <th className="th_01"><InlineMath>{`\\displaystyle x `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle \\mu `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle \\sigma `}</InlineMath></th>
              <th className="th_01"><InlineMath>{`\\displaystyle P \\left(X | \\mu, \\sigma \\right)`}</InlineMath></th>
            </tr>
              {list}
        </table>

      </div>
    )   
  }
}

export default Norm;
